<template>
  <div>
    <list listTitle="Anúncios" :listLogo="module.logo" filterTitle="Filtros" :loading="loading" :total="productsMarketplaceTotal" :sortFields="sortFields" :sortDefault="{ field: sortFields[0], order: 'desc' }" @change="onChange">
      <template slot="filters">
        <form-group label="Código do produto">
          <vue-tags-input
            class="form-input"
            v-model="options.code"
            :tags="productCodes"
            :separators="[',']"
            :add-on-key="[',']"
            placeholder=""
            @tags-changed="newCodes => productCodes = newCodes"/>

          <small class="form-help">Utilize vírgula (,) para múltiplos códigos.</small>
        </form-group>

        <form-group label="EAN do produto">
          <input class="form-input" v-model="options.ean">
        </form-group>
        <form-group label="Título do produto">
          <input class="form-input" v-model="options.title">
        </form-group>
        <form-group label="Status do produto">
          <select v-model="options.status" class="form-select">
            <option value="">Todos</option>
            <option v-for="status in productStatuses" :key="status" :value="status">
              {{ $te(`${moduleDI.identifier}.status.${status}.label`) ? $t(`${moduleDI.identifier}.status.${status}.label`) : $t(`${status}.label`) }}
            </option>
          </select>
        </form-group>
        <form-group label="Status do preço do produto">
          <select v-model="options.priceStatus" class="form-select">
            <option value="">Todos</option>
            <option v-for="status in productPriceStatuses" :key="status" :value="status">{{ $t(`${status}.label`) }}</option>
          </select>
        </form-group>
        <form-group label="Status do estoque do produto">
          <select v-model="options.stockStatus" class="form-select">
            <option value="">Todos</option>
            <option v-for="status in productStockStatuses" :key="status" :value="status">{{ $t(`${status}.label`) }}</option>
          </select>
        </form-group>
        <form-group label="Conta">
          <select v-model="options.account" class="form-select">
            <option value="">Todas</option>
            <option v-for="account in productAccounts" :key="account" :value="account.identifier">{{ account.nickname }}</option>
          </select>
        </form-group>
        <form-group label="Tipo de preço">
          <select v-model="options.priceType" class="form-select">
            <option value="">Todos</option>
            <option v-for="priceType in productPriceTypes" :key="priceType" :value="priceType">{{ $t(`${priceType}.label`) }}</option>
          </select>
        </form-group>
        <form-group :label="$t(`saleAvailability.label`)">
          <select v-model="options.saleAvailability" class="form-select">
            <option :value=null>Todos</option>
            <option v-for="saleAvailability in productSaleAvailabilities" :key="saleAvailability"
                    :value="saleAvailability">{{ $t(`saleAvailability.${saleAvailability}.label`) }}
            </option>
          </select>
        </form-group>
        <form-group label="Tipo checkout">
          <select v-model="options.typeCheckout" class="form-select">
            <option :value=null>Todos</option>
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select>
        </form-group>
        <form-group label="Frete grátis">
          <select v-model="options.shippingFree" class="form-select">
            <option :value=null>Todos</option>
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select>
        </form-group>
        <form-group :label="$t('productGroupedId.label')">
          <input class="form-input" v-model="options.productId">
        </form-group>
        <slot name="custom-filters"/>
      </template>
      <div class="l-col-12@md" v-for="(item, index) in productsMarketplaceItems" :key="index">
        <announcement-card ref="items" :product="item" :module="moduleDI"/>
      </div>
      <div class="l-col u-textCenter" v-if="!productsMarketplaceItems.length">
        <panel>
          Nenhum produto encontrado.
        </panel>
      </div>
    </list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { merge } from 'lodash'
  import FormGroup from '@/components/template/FormGroup'
  import AnnouncementCard from '@/components/marketplace/mercadoLivre/AnnouncementCard'
  import List from '@/components/shared/list/Paginator'
  import api from '@/api'
  import BulkActions from '@/components/shared/BulkActions'
  import Panel from '@/components/template/Panel'
  import VueTagsInput from '@johmun/vue-tags-input'

  export default {
    data: () => ({
      moduleDI: {
        type: 'marketplace',
        identifier: 'mercadoLivre'
      },
      sortFields: [
        'createdAt',
        'title'
      ],
      loading: false,
      productStatuses: [],
      productPriceStatuses: [],
      productStockStatuses: [],
      productAccounts: [],
      productCodes: [],
      productPriceTypes: [],
      productSaleAvailabilities: [],
      options: {
        code: '',
        title: '',
        ean: '',
        status: '',
        priceStatus: '',
        stockStatus: '',
        account: '',
        priceType: '',
        saleAvailability: null,
        productId: null,
        typeCheckout: null,
        shippingFree: null
      }
    }),
    props: {
      customBulkActions: {
        type: Array,
        required: false
      },
      customFilters: {
        type: Object,
        required: false
      }
    },
    mounted () {
      Promise.all([
        api.getProductStatuses(this.moduleDI.type, this.moduleDI.identifier)
          .then(productStatuses => {
            this.productStatuses = productStatuses
          })
          .catch(() => {
            this.productStatuses = []
          }),
        api.getProductPriceStatuses(this.moduleDI.type, this.moduleDI.identifier)
          .then(productPriceStatuses => {
            this.productPriceStatuses = productPriceStatuses
          })
          .catch(() => {
            this.productPriceStatuses = []
          }),
        api.getProductPriceTypes(this.moduleDI.type, this.moduleDI.identifier)
          .then(productPriceTypes => {
            this.productPriceTypes = productPriceTypes
          })
          .catch(() => {
            this.productPriceTypes = []
          }),
        api.getProductStockStatuses(this.moduleDI.type, this.moduleDI.identifier)
          .then(productStockStatuses => {
            this.productStockStatuses = productStockStatuses
          })
          .catch(() => {
            this.productStockStatuses = []
          }),
        api.getProductMercadoLivreAccounts()
          .then(productAccounts => {
            this.productAccounts = productAccounts
          })
          .catch(() => {
            this.productAccounts = []
          }),
        api.getProductSaleAvailabilities('marketplace', this.moduleDI.identifier)
          .then(productSaleAvailabilities => {
            this.productSaleAvailabilities = productSaleAvailabilities
          })
          .catch(() => { this.productSaleAvailabilities = [] })
      ])
        .then(() => {
          if (this.customBulkActions !== null && this.customBulkActions !== undefined) {
            this.customBulkActions.forEach((item) => {
              this.bulkActions.push(item)
            })
          }

          merge(this.options, this.customFilters)
        })
    },
    created () {
      this.clear()
      this.clearProductsMarketplace()
    },
    methods: {
      ...mapActions('productsMarketplace', [
        'fetch',
        'clearProductsMarketplace'
      ]),
      ...mapActions('itemsSelected', [
        'clear'
      ]),
      async onChange (options) {
        this.loading = true

        merge(options, this.customFilters)
        merge(this.options, options)

        const codes = []

        if (this.options.code !== '') {
          codes.push(this.options.code)
        }

        for (let i in this.productCodes) {
          codes.push(this.productCodes[i].text)
        }

        this.options.code = codes.join(',')

        this.clearProductsMarketplace()

        await this.fetch({
          type: this.moduleDI.type,
          identifier: this.moduleDI.identifier,
          options: this.options
        })

        this.loading = false
        this.options.code = ''
      },
      applyBulkAction (action) {
        this.$router.push(`/${this.moduleDI.type}/${this.moduleDI.identifier}/${action}`)
      }
    },
    computed: {
      ...mapFields({
        productsMarketplaceTotal: 'productsMarketplace.total',
        productsMarketplaceItems: 'productsMarketplace.items',
        productsMarketplaceLastFetchOptions: 'productsMarketplace.lastFetchOptions'
      }),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      module () {
        return this.getDefinitionModuleByIdentifierAndType(this.moduleDI.type, this.moduleDI.identifier)
      }
    },
    components: {
      FormGroup,
      List,
      BulkActions,
      AnnouncementCard,
      Panel,
      VueTagsInput
    }
  }
</script>

<style scoped lang="sass">
  .count-selected
    margin-top: 4px

  .logo
    max-height: 30px
    margin-right: 20px

    .title
      margin-top: 16px
      margin-left: 20px

    .paginator
      float: right
</style>



// WEBPACK FOOTER //
// List.vue?40b8f0af